import React from 'react';
import { array, func, string } from 'prop-types';
import classnames from 'classnames/bind';

import SectionNavigationItem from '../SectionNavigationItem';

import useSticky from '@dragonfruit/containers/Premium/hooks/useSticky.js';

import styles from './SectionNavigation.scss';

const cx = classnames.bind(styles);

function SectionNavigation({
  activeName,
  navigatorList,
  onClickNavigationItem,
}) {
  const { isSticky, element } = useSticky();

  return (
    <React.Fragment>
      <div className={cx(styles.root, { isSticky })}>
        <nav ref={element} className={styles.inner}>
          {navigatorList.map((sectionData, sectionIdx) => {
            const { sectionName, navIcon } = sectionData;
            return (
              <SectionNavigationItem
                {...sectionData}
                key={sectionIdx}
                name={sectionName}
                icon={navIcon}
                isSticky={isSticky}
                active={activeName === sectionName}
                className={styles[`nav_${sectionData.className}`]}
                onClick={onClickNavigationItem}
              />
            );
          })}
        </nav>
      </div>
    </React.Fragment>
  );
}

SectionNavigation.propTypes = {
  activeName: string.isRequired,
  onClickNavigationItem: func.isRequired,
  children: array,
  navigatorList: array,
};

SectionNavigation.defaultProps = {
  children: [],
};

export default SectionNavigation;



// WEBPACK FOOTER //
// ./app/containers/Premium/components/SectionNavigation/SectionNavigation.jsx